import { render } from 'preact';
import { App } from './components/App';

// Initialize Telegram WebApp
const tg = (window as any).Telegram?.WebApp;
if (tg) {
  tg.ready();
  tg.expand();
  tg.setHeaderColor('#1a1a2e');
  tg.setBackgroundColor('#1a1a2e');
  if (tg.disableVerticalSwipes) {
    tg.disableVerticalSwipes();
  }
}

render(<App />, document.getElementById('app')!);
